import React, { ComponentProps, FunctionComponent } from "react";

const ChatBubbleEllipsisIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 21",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.53627 0.00103398H15.6241C25.6673 0.00103398 25.6602 16.747 15.6241 16.747H14.0223L8.33672 20.8444C7.79132 21.2367 7.04061 20.8391 7.04061 20.1883L7.0397 16.7299C-2.58744 16.0953 -2.26282 0 7.53715 0L7.53627 0.00103398ZM17.7821 6.1908C18.9299 6.1908 19.8597 7.11349 19.8597 8.25253C19.8597 9.39154 18.9299 10.3143 17.7821 10.3143C16.6343 10.3143 15.7045 9.39156 15.7045 8.25253C15.7045 7.11352 16.6343 6.1908 17.7821 6.1908ZM11.5802 6.1908C12.728 6.1908 13.6578 7.11349 13.6578 8.25253C13.6578 9.39154 12.728 10.3143 11.5802 10.3143C10.4324 10.3143 9.50262 9.39156 9.50262 8.25253C9.50262 7.11352 10.4324 6.1908 11.5802 6.1908ZM5.37828 6.1908C6.52605 6.1908 7.45586 7.11349 7.45586 8.25253C7.45586 9.39154 6.52607 10.3143 5.37828 10.3143C4.2305 10.3143 3.30071 9.39156 3.30071 8.25253C3.30071 7.11352 4.2305 6.1908 5.37828 6.1908ZM15.6241 1.62488H7.53627C-0.257504 1.62488 -0.437645 15.1234 7.53627 15.1234C8.0871 15.1234 8.67501 15.224 8.67501 15.9357V18.597C9.39497 18.0782 13.2119 15.1235 13.7581 15.1235H15.624C23.5002 15.1235 23.492 1.62488 15.6241 1.62488Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(
  ChatBubbleEllipsisIcon
) as FunctionComponent<ComponentProps<"svg">>;

export default ForwardRef;
